module.exports = __webpack_public_path__ + "static/img/nav_bg_3.7fc62f42.png";